import React from "react";
import Header from "../sharedComponents/header/header";
import "./thankYouPage.scss";
import { inject, observer } from "mobx-react";
import { PolicyStore } from "../../stores/policyStore";
import { UiFlagsStore } from "../../stores/uiFlagsStore";
import { CalculateStore } from "../../stores/calculateStore";
import { ClientStore } from "../../stores/clientStore";
import { ProposalStore } from "../../stores/proposalStore";
import DownloadDocuments from "../sharedComponents/downloadDocuments/downloadDocuments";
import { HttpError } from "../sharedComponents/notification/httpError";
import { DocumentStore, FilesKeys } from "../../stores/documentStore";
import Formatter from "../../helpers/formatter";
import { PaymentMethodTypes } from "../../helpers/paymentMethod";
import { RetrieveCalculationService } from "../../services/services/retrieveCalculationService";
import { PolicyService } from "../../services/services/policyService";

interface ThankYouPageProps {
  policyStore?: PolicyStore;
  uiFlagsStore?: UiFlagsStore;
  calculateStore?: CalculateStore;
  clientStore?: ClientStore;
  proposalStore?: ProposalStore;
  documentStore?: DocumentStore;
  retrieveCalculationService?: RetrieveCalculationService;
  policyService?: PolicyService;
}

interface ThankYouPageState {
  renderError: boolean;
}

@inject("policyStore", "uiFlagsStore", "calculateStore", "clientStore", "proposalStore", "documentStore", "retrieveCalculationService", "policyService")
@observer
export default class ThankYouPage extends React.Component<ThankYouPageProps, ThankYouPageState> {

  constructor(props: any) {
    super(props);

    this.state = {
      renderError: false
    };
  }

  private getDownloadFiles() {
    const downloadFiles = [FilesKeys.productCard, FilesKeys.generalTermsAndConditions, FilesKeys.policy];

    if (this.props.proposalStore?.paymentMethod === PaymentMethodTypes.TRANSFER) {
      downloadFiles.push(FilesKeys.paymentForm);
    }

    return downloadFiles;
  }

  public render() {
    return this.props.uiFlagsStore!.isClientEndsSelected ? this.renderClientEndsContent() : this.renderPolicyContent();
  }

  private renderClientEndsContent() {
    return (
      <div className="content thank-you-page">
        <Header type="big"
          mainHeader="Wysłano link do oferty"
        />

        <div className="direct-content">
          <p>
            Link do oferty został wygenerowany i wysłany na
            adres: <b>{this.props.clientStore!.emailForClientEnds.value}</b>
          </p>
        </div>

        <div className="new-calc" onClick={() => this.newCalculation()}>
          Rozpocznij nową kalkulację
        </div>
      </div>
    );
  }

  private renderPolicyContent() {
    const downloadFiles = this.getDownloadFiles();

    return (
      <div className="content thank-you-page">
        <div className="policy-id">
          Numer polisy: <span>{this.props.policyStore!.policyResponse.policyNumber}</span>
        </div>
        {this.props.uiFlagsStore!.isDirect ? this.renderDirectContent(downloadFiles) : this.renderAgentContent(downloadFiles)}
        <DownloadDocuments
          buttonLabel="Pobierz dokumenty"
          displayAdditionalInfo={true}
          downloadFiles={downloadFiles}
          onClick={() => this.setState({ renderError: true })}
        />
        <div className="new-calc" onClick={() => this.newCalculation()}>
          Rozpocznij nową kalkulację
        </div>
      </div>
    );
  }

  private renderAgentContent(downloadFiles: FilesKeys[]) {
    return (<>
      <Header type="big"
        mainHeader="Dane do wystawienia polisy zostały zatwierdzone"
      />

      {this.renderHttpError(downloadFiles)}

      <Header type="small" mainHeader="Następne kroki to:" />

      <ol className="next-steps">
        <li>Pobierz i wydrukuj polisę i niezbędne załączniki.</li>
        <li>Podpisz polisę i załączniki i przekaż je Ubezpieczającemu.</li>
      </ol>
    </>);
  }

  private renderDirectContent(downloadFiles: FilesKeys[]) {

    return (<>
      <Header type="big"
        mainHeader={
          <div className="direct-header">
            <div>Dziękujemy za zakup ubezpieczenia Bezpieczny Dom.</div>
            <div>Z nami bezpiecznie i wygodnie.</div>
          </div>
        }
      />

      {this.renderHttpError(downloadFiles)}

      <div className="direct-content">
        <p>
          Na Twój adres e-mail przesłaliśmy dokumenty dotyczące umowy ubezpieczenia.
        </p>
        <p>
          Ochrona rozpocznie się po opłaceniu składki lub pierwszej raty do
          dnia <b>{Formatter.getStringDate(this.props.calculateStore!.additionalQuestions.startDate)}</b>.
        </p>
      </div>
    </>);
  }

  private renderHttpError(downloadFiles: FilesKeys[]) {
    let failed = false;
    let failedFiles = "Wystąpił błąd przy próbie pobierania pliku: ";
    for (const key in downloadFiles) {
      if (this.props.documentStore!.getFileRequestStatus(downloadFiles[key])?.isError && this.state.renderError) {
        failed = true;
        failedFiles += this.props.documentStore!.getFileName(downloadFiles[key]) + ", ";
      }
    }

    if (failed) {
      const errorMessage = <>
        <div>{failedFiles.substring(0, failedFiles.length - 2)}.</div>
        <div>
          Spróbuj ponownie później, bądź skontaktuj się z nami pod
          numerem <a href="tel:223276060">22 327 60 60</a>.
        </div>
      </>;
      return (
        <HttpError
          customizedErrorMessage={errorMessage}
          type={"http"}
        />
      );
    }

    return null;
  }

  private newCalculation() {
    this.resetStoresAndService();
    this.props.uiFlagsStore!.goToNewCalculation();
  }

  private resetStoresAndService() {
    this.props.calculateStore!.resetStore();
    this.props.clientStore!.resetStore();
    this.props.proposalStore!.resetStore();
    this.props.policyStore!.resetStore();
    this.props.retrieveCalculationService!.reset();
    this.props.policyService!.reset();
  }
}
